/*
 * @Author: Dong
 * @Date: 2022-04-20 11:14:22
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-05-06 10:46:52
 */
import {
  CHANGE_TAB,
  UPDATE_QUEUE,
  ADD_QUEUE,
  DELETE_QUEUE,
  SELECT_VERSION,
  CLEAR_FILE_CONFIG,
  CHAGNE_FORM,
  CHANGE_SYSTEM,
  SET_SOURCE_DATA,
  SET_UPDATE_METHOD,
} from '../constant';

export const changeTab = (payload: any) => ({
  type: CHANGE_TAB,
  payload,
});

export const updateQueue = (payload: { uploadPrecent: number; name?: string; path?: string }) => ({
  type: UPDATE_QUEUE,
  payload,
});

export const addQueue = (payload: any) => ({
  type: ADD_QUEUE,
  payload,
});

export const deleteQueue = (payload: any) => ({
  type: DELETE_QUEUE,
  payload,
});

export const selectVersion = (payload: any) => ({
  type: SELECT_VERSION,
  payload,
});

export const clearData = () => ({
  type: CLEAR_FILE_CONFIG,
});

export const changeForm = (payload: any) => ({
  type: CHAGNE_FORM,
  payload,
});

export const changeSystem = (payload: any) => ({
  type: CHANGE_SYSTEM,
  payload,
});

export const setSourceData = (payload: string) => ({
  type: SET_SOURCE_DATA,
  payload,
});

export const setUpdateMethod = (payload: string) => ({
  type: SET_UPDATE_METHOD,
  payload,
});
